/**
 * oem定制 模块接口
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

// 和教育
const cloudEducation = {
  // ----------------学生-----------------------------------
  /**
   * 获取和教育学校
   */
  getCloudSchools(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getSchool`,
      headers: config.headers,
      params
    });
  },
  /**
   * 学生tab——获取列表
   */
  getStudentList(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getStudentlList`,
      headers: config.headers,
      params
    });
  },
  /**
   * 学生tab——和教育数据更新
   */
  updateStudentList(params) {
    return requestByGateway({
      method: 'get',
      params: { province: params.province },
      url: `${config.api.cloudEducation}/updateStudentData/${params.school_id}`,
      headers: config.headers
    });
  },
  /**
   * 学生tab——十牛信息同步
   */
  syncStudentList(params) {
    return requestByGateway({
      method: 'get',
      params: { province: params.province },
      url: `${config.api.cloudEducation}/studentDataSync/${params.school_id}`,
      headers: config.headers
    });
  },
  /**
   * 学生tab——获取十牛学生列表
   */
  getXStudents(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getOurStudentList`,
      headers: config.headers,
      params
    });
  },
  /**
   * 学生tab——手动改变关联状态
   */
  swtichStudentStatus(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/studentSync`,
      headers: config.headers,
      params
    });
  },
  // ----------------学校-----------------------------------
  /**
   * 学校tab——获取市镇
   */
  getCloudTowns(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getTown`,
      headers: config.headers,
      params
    });
  },
  /**
   * 学校tab——获取列表
   */
  getSchoolList(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getSchoolList`,
      headers: config.headers,
      params
    });
  },
  /**
   * 学校tab——和教育数据更新
   */
  updateSchoolList(params) {
    return requestByGateway({
      method: 'get',
      params,
      url: `${config.api.cloudEducation}/updateSchoolData`,
      headers: config.headers
    });
  },
  /**
   * 学校tab——获取十牛的学校列表
   */
  getXSchools(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getOurSchoolList`,
      headers: config.headers,
      params
    });
  },
  /**
   * 学校tab——手动改变关联状态
   */
  swtichSchoolStatus(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/schoolSync`,
      headers: config.headers,
      params
    });
  },
  // ----------------市镇-----------------------------------
  /**
   * 市镇——获取市
   */
  getCloudCities(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getCity`,
      headers: config.headers,
      params
    });
  },
  /**
   * 市镇——获取列表
   */
  getCityList(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getCityList`,
      headers: config.headers,
      params
    });
  },
  /**
   * 市镇——获取列表
   */
  updateTownList(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/updateCityData`,
      headers: config.headers,
      params
    });
  },
  /**
   * 市镇——获取十牛的学校列表
   */
  getXTowns(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getOurAreaList`,
      headers: config.headers,
      params
    });
  },
  /**
   * 市镇——手动改变关联状态
   */
  swtichTownStatus(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/areaSync`,
      headers: config.headers,
      params
    });
  },
  // ----------------开通状态-----------------------------------
  /**
   * 获取列表
   */
  getSyncList(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getSynclist`,
      headers: config.headers,
      params
    });
  },
  /**
   * 获取列表
   */
  switchSyncStatus(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/statusModify`,
      headers: config.headers,
      params
    });
  },
  getOemSchoolList(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.schoolstruct}/SchoolStruct/School/list_oem_agent_school`,
      headers: config.headers,
      params
    });
  },
  getSchoolByOurId(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/getSchoolByOur`,
      headers: config.headers,
      params
    });
  },
  getUserOemAgentId(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.admin}/agent/get_account_oem`,
      headers: config.headers,
      params
    });
  },
  deleteStudent(data) {
    return requestByGateway({
      method: 'post',
      url: `${config.api.cloudEducation}/deleteStudent/hjy`,
      headers: config.headers,
      data: qs.stringify(data)
    });
  },
  updateTeacherList(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/hjy/schoolAllTeacherSync`,
      headers: config.headers,
      params
    });
  },
  getTeacherList(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/hjy/teacherList`,
      headers: config.headers,
      params
    });
  },
  syncTeacherList(params) {
    return requestByGateway({
      method: 'post',
      data: qs.stringify(params),
      url: `${config.api.cloudEducation}/hjy/autoSyncTeacher`,
      headers: config.headers
    });
  },
  swtichTeacherStatus(params) {
    return requestByGateway({
      method: 'post',
      url: `${config.api.cloudEducation}/hjy/manualOperationSync`,
      headers: config.headers,
      data: qs.stringify(params)
    });
  },
  deleteTeacher(data) {
    return requestByGateway({
      method: 'post',
      url: `${config.api.cloudEducation}/hjy/deleteTeacher`,
      headers: config.headers,
      data: qs.stringify(data)
    });
  },
  getXTeachers(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/hjy/queryOurSchoolTeacher`,
      headers: config.headers,
      params
    });
  },
  getPrimaryXBullStudentList(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/primaryOurStudentList`,
      headers: config.headers,
      params
    });
  },
  updateLogStatus(data) {
    return requestByGateway({
      method: 'post',
      url: `${config.api.cloudEducation}/updateSyncLogSend`,
      headers: config.headers,
      data: qs.stringify(data)
    });
  },
  syncAllClazz(data){
    return requestByGateway({
      method: 'post',
      url: `${config.api.cloudEducation}/sync/school_all_class`,
      headers: config.headers,
      data: qs.stringify(data)
    });
  },
  syncOneClazz(data){
    return requestByGateway({
      method: 'post',
      url: `${config.api.cloudEducation}/sync/school_one_class`,
      headers: config.headers,
      data: qs.stringify(data)
    });
  },
  findAllSyncRecords(params){
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/sync/all_sync_record`,
      headers: config.headers,
      params
    });
  },
  findAllSchoolGz(params) {
    return requestByGateway({
      method: 'get',
      url: `${config.api.cloudEducation}/sync/school_all_gz`,
      headers: config.headers,
      params
    });
  },
  syncSchoolAllClassByIds(data) {
    return requestByGateway({
      method: 'post',
      url: `${config.api.cloudEducation}/sync/school_all_class_ids`,
      headers: config.headers,
      data: qs.stringify(data)
    });
  },
    studentAllUpdate(data) {
        return requestByGateway({
            method: 'post',
            url: `${config.api.cloudEducation}/updateAll/hjy`,
            headers: config.headers,
            data: qs.stringify(data)
        });
    },
};

const oem = {
  cloudEducation
};

export default oem;
